import React from "react";
import { Select, DatePicker, Button } from "antd";
import { DATE_PRESETS } from "../../helpers/systemFilters";
import "./SystemFilterBar.scss";

const { RangePicker } = DatePicker;

// Header filter shared by the system pages (Chat, CRM, Email, …). Mirrors the
// Automation Pipeline's brand scoping and adds the standard date presets
// (Today / Last week / Last month / Custom, defaulting to All time). The parent
// owns the filter state and the filtered list — this just renders the controls
// and reports changes through setFilters.
//
//   filters: { brandId, datePreset, customRange: [moment, moment] | null }
//   brands:  array of { _id, title|name }
export default function SystemFilterBar({
  filters = {},
  setFilters,
  brands = [],
  resultCount,
  totalCount,
}) {
  const datePreset = filters.datePreset || "all";
  const set = (patch) => setFilters({ ...filters, ...patch });
  const onClear = () =>
    setFilters({ brandId: undefined, datePreset: "all", customRange: null });
  const dirty = !!(filters.brandId || (datePreset && datePreset !== "all"));

  return (
    <div className="system-filter-bar">
      <Select
        allowClear
        showSearch
        placeholder="All brands"
        value={filters.brandId}
        onChange={(v) => set({ brandId: v })}
        optionFilterProp="label"
        style={{ width: 200 }}
        options={brands.map((b) => ({
          value: b._id,
          label: b.title || b.name || b._id,
        }))}
      />

      <Select
        value={datePreset}
        onChange={(v) =>
          set({ datePreset: v, customRange: v === "custom" ? filters.customRange : null })
        }
        style={{ width: 150 }}
        options={DATE_PRESETS.map((p) => ({ value: p.key, label: p.label }))}
      />

      {datePreset === "custom" && (
        <RangePicker
          value={filters.customRange || null}
          onChange={(v) => set({ customRange: v })}
          allowClear
        />
      )}

      {dirty && (
        <Button onClick={onClear} type="link">
          Clear
        </Button>
      )}

      <span className="sfb-count">
        {resultCount != null && totalCount != null
          ? `${resultCount} of ${totalCount}`
          : resultCount != null
            ? `${resultCount}`
            : ""}
      </span>
    </div>
  );
}
